import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { Typography } from "@mui/material";
import { instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { Loading } from "../Components/Loading";
import { useNavigate, useSearchParams } from "react-router-dom";

function UsuarioVerificar() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [dialog, setDialog] = React.useState({ title: "", text: "" });
  const [openDialog, setOpenDialog] = React.useState(false);
  const [sendToken, setSendtoken] = React.useState(false);
  const navigate = useNavigate();
  if (!sendToken) {
    instance
      .post("/auth/verify", {
        token: searchParams.get("token"),
      })
      .then((res) => {
        console.info("Verificado exitosamente");
        console.log(res);
        // setDialogText('Se ha enviado un correo para activar el usuario al correo registrado '+info.email.value)
        setDialog({
          title: "Verificación exitosa",
          text: "Se ha verificado exitosamente la dirección de correo electrónico",
          redirect: true,
          page: "/Login",
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
            redirect: true,
            page: "/Login",
          });
        } else {
          setDialog({
            title: "ERROR",
            text: err.response.data.message,
            redirect: true,
            page: "/Login",
          });
        }
      })
      .finally(() => {
        setOpenDialog(true);
        setSendtoken(true);
      });
  }

  return (
    <>
      <Container
        component="main"
        maxWidth="sm"
        className="bordered-box"
        sx={{
          padding: "4px",
          marginTop: 8,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <Typography component="h1" variant="h5">
            Verificación de cuenta
          </Typography>
          <Loading />
        </Box>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </>
  );
}

export { UsuarioVerificar };
